import React, { useState, useEffect } from "react";
// import SideBar from "../components/sidebar";
import { Button, Form, Toast } from "react-bootstrap";
// import { Link } from "react-router-dom";
import Table from "../components/tables/table";
import { Formik } from "formik";
import * as yup from "yup";

import {
  postMethod,
  postMethodFormData,
  AccessDenied,
  handleFalseStatus,
  isNotLoading,
  getMethod,
} from "../Library";

import ModalPop from "../components/modals";
// import ImageBoxUpload from "../components/ImageBox/imageboxupload";
import ImageBoxUploadCrop from "../components/ImageBox/imageboxuploadcrop";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

export default function EquipmentPage(props) {
  const [tableList, setTableList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [modalHead, setModalHead] = useState();
  const [formDirty, setFormDirty] = useState(false);
  const [isImage, setFormImage] = useState(false);
  const [formInputs, setFormInputs] = useState();
  const [editId, setEditId] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const showToastFn = (msg) => {
    setShowToast(true);
    if (typeof msg == "string") {
      setToastMessage(msg);
    } else {
      setToastMessage(JSON.stringify(msg, null, 2));
    }
  };

  let formDataBody = new FormData();

  function btnFormatter(cell, row) {
    return (
      <>
        <Button
          variant="link"
          dataid={row.id}
          onClick={() => {
            editEquipment(row);
            setModalShow(true);
            setModalHead("Edit");
          }}
        >
          <FontAwesomeIcon icon={faPen} />
        </Button>
        |
        <Button variant="link" dataid={row.id} onClick={trashWorkout}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </Button>
      </>
    );
  }

  const trashWorkout = (e) => {
    let id = e.target.getAttribute("dataid");
    const data = {
      url: "equipment_delete",
      body: {
        id: id,
      },
    };
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to do this ?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const newData = await postMethod(data);

            showToastFn(newData.message);
            if (newData.status === 1) {
              isNotLoading();
              getTableList();
            }
            else {
              isNotLoading();
            }
          },
        },
        {
          label: "No",
          // onClick: () => console.log("Clicked No"),
        },
      ],
    });
  };
  const columns = [
    { dataField: "sno", text: "S.No", searchable: false },
    { dataField: "name", text: "Equipment Name" },
    {
      dataField: "id",
      text: "Action",
      searchable: false,
      formatter: btnFormatter,
    },
  ];

  useEffect(() => {
    props.getMenuList();
    setPageLoaded(true);
  }, []);

  useEffect(() => {
    if (pageLoaded) {
      getTableList();
      if (editId) {
        // console.log("EDITiD", editId);
        // getEditData(props.editId);
      } else {
        setFormInputs({
          name: "",
          image_url: "",
        });
      }
    }
  }, [pageLoaded, setPageLoaded]);

  // editEquipment
  const editEquipment = (data) => {
    let form = { ...formInputs };
    form["name"] = data.name;
    form["id"] = data.id;
    if (data.image_url) {
      form["image_url"] = data.image_url;
    }
    setFormInputs(form);
  };

  // getFaqTable data
  const getTableList = async () => {
    const data = {
      url: "equipment_list",

    };
    let tableList = await getMethod(data);
    if (tableList.status === 1) {
      isNotLoading();
      setTableList(tableList.data.equipments);
    } else if (tableList.status === false) {
      isNotLoading();
      handleFalseStatus(tableList);
    } else if (tableList.status === 0) {
      isNotLoading();
      setTableList([]);
    }
  };

  // form functions
  const formSchema = yup.object({
    name: yup.string().required("This field is required"),
  });

  const handleInput = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    let form = { ...formInputs };
    form[name] = value;
    setFormInputs(form);
  };

  const chooseImageFn = (url) => {
    let form = { ...formInputs };
    form.image_url = url;
    setFormInputs(form);
  };

  const handleSubmit = () => {
    // console.log("formIn", formInputs);
    for (const [key, value] of Object.entries(formInputs)) {
      formDataBody.append(key, value);
    }
    addNewEquipment();
  };

  // add new equipmeny
  const addNewEquipment = async (type) => {
    const data = {
      url: "equipment_create_or_update",
      body: formDataBody,
    };
    const newData = await postMethodFormData(data);

    showToastFn(newData.message);
    if (newData.status == 1) {
      isNotLoading();
      closeModal();
      getTableList();
    }
    else {
      isNotLoading();
    }
  };

  const closeModal = () => {
    setModalShow(false);
    setFormInputs({});
    setFormDirty(false);
  };

  const modalBody = () => {
    return (
      <Formik
        validationSchema={formSchema}
        onSubmit={(values, actions) => {
          // console.log("name");
          if (values) {
            setFormImage(false);
            handleSubmit();
          } else {
            setFormImage(true);
          }
        }}
        initialValues={{
          name: formInputs && formInputs.name ? formInputs.name : "",
          image_url:
            formInputs && formInputs.image_url ? formInputs.image_url : "",
        }}
      >
        {({
          validateForm,
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          dirty,
          isValid,
          isInvalid,
          errors,
        }) => (
          <Form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
              setFormDirty(true);
            }}
          >
            <div className="column">
              <div className="col-md-8">
                <Form.Group controlId="name">
                  <Form.Label className="required">Equipment name</Form.Label>
                  <Form.Control
                    name="name"
                    type="text"
                    required
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      handleInput(e);
                    }}
                    isInvalid={errors.name && touched.name ? true : false}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="col-md-4 position-relative">
                {/* <ImageBoxUpload
                  data={chooseImageFn}
                  image_url={formInputs ? formInputs.image_url : ""}
                /> */}
                <div className="eq-image-label">
                  35x35
                </div>
                <ImageBoxUploadCrop
                  folder="equipment"
                  width="35"
                  height="35"
                  as_w="1"
                  as_h="1"
                  // as_w="4"
                  // as_h="3"
                  dataid=""
                  data={chooseImageFn}
                  image_url={formInputs ? formInputs.image_url : ""}
                />

                {/* {isImage  ? (
                    <div className="err-feedback">This field is required</div>
                ):""} */}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-5">
              <Button
                variant="secondary"
                onClick={() => {
                  closeModal();
                }}
                className="mr-3"
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                {modalHead == "Add" ? "Add" : "Update"}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  const tableFilters = () => {
    return <> </>;
  };

  return (
    <section className="rightContent">
      {props.menuList.includes(9.2) ? (
        <>
          <div className="d-flex align-items-center mb-3 justify-content-between">
            <h3 className="text-capitalize">Manage Equipments</h3>
            <Button
              className="h-100"
              onClick={() => {
                setModalShow(true);
                setModalHead("Add");
              }}
            >
              Add new
            </Button>
          </div>
          <Table data={tableList} columns={columns} filters={tableFilters} />
          <ModalPop
            show={modalShow}
            onHide={() => {
              closeModal();
            }}
            modalcontent={modalBody()}
            modalhead={`${modalHead} equipment`}
          />
          <div className="toastMessage">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={4000}
              autohide
            >
              <Toast.Body> {toastMessage} </Toast.Body>
            </Toast>
          </div>
        </>
      ) : (
        <AccessDenied />
      )}
    </section>
  );
}
